import Swiper, { Pagination, Navigation } from 'swiper'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
export class specSlider {
  constructor() {
    if (document.getElementById('js-products_spec') === null) return
    let slider = document.getElementById('js-products_spec')
    let swiperNum = slider.querySelectorAll('.swiper-slide')
    let option = {}
    if (swiperNum.length > 1) {
      const specSlider = new Swiper('#js-products_spec', {
        modules: [Pagination, Navigation],
        pagination: {
          el: '.js-swiper_dot',
          type: 'bullets',
        },
        navigation: {
          prevEl: '.js-swiper_prev',
          nextEl: '.js-swiper_next',
        },
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
      })
    } else {
      slider.querySelector('.js-products_spec_control').classList.add('is-hidden')
    }
  }
}
